// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IDLu","title":"styles_title__Qf5dF"};